import React, { Fragment, useEffect, useState } from "react"

import { connect } from "react-redux"
import { createStructuredSelector } from "reselect"
import { compose } from "redux"

import PropTypes from "prop-types"

import injectSaga from "utils/injectSaga"
import injectReducer from "utils/injectReducer"

import reducer from "./reducer"
import saga from "./saga"
import {
  makeSelectIsLoadingQuestions,
  makeSelectQuestions,
  makeSelectOnlyQuestions,
} from "./selectors"
import { getListQuestionsWatcher } from "./actions"

import {
  isAmbassadorActive,
  LOCAL_CHECKBOX_EXCLUDE,
  LOCAL_ISOLATED_METRICS,
} from "../../../utils/storage"
import { QualitativeQuestion } from "../../../containers/Report/Home/Components/QualitativeQuestion"
import { validate } from "../../../utils/functions"
import { Spin } from "antd"

import "../../../Reports/components/WidgetQualitativeQuestion/index.less"

export function WidgetQualitativeQuestion(props) {
  const [divisionID] = useState(props.idDivisionSelected)

  const isAmbassador = isAmbassadorActive()
    ? validate.exist(divisionID)
      ? `?id_division=${divisionID}`
      : validate.exist(props.idDivisionParent)
      ? `?id_division=${props.idDivisionParent}`
      : ""
    : ""

  useEffect(() => {
    initGetData()
    // measureGeneral/measureTotal se re-cargan async (independiente) al cambiar
    // de segmento vía ReportAdmin.getStatus — sin esta dependencia el fetch de
    // acá dispara con datos del segmento anterior (id_survey stale) y, si falla,
    // queda pegado en [] porque nada vuelve a disparar el efecto (VLENG-11404).
  }, [
    props.idMeasure,
    props.idDivisionSelected,
    props.selectedSegment,
    props.measureGeneral,
    props.measureTotal,
  ])

  const initGetData = () => {
    const {
      idMeasure,
      getListQuestions,
      idDivisionSelected,
      idDivisionParent,
      measureGeneral,
      selectedSegment,
      measureTotal,
    } = props

    if (!validate.exist(measureGeneral) || !validate.exist(measureTotal)) return

    const params = {
      isHome: true,
      id_measure: idMeasure,
      id_survey: measureTotal.id_survey,
      id_survey_type: measureGeneral.id_survey_type,
      id_segment: selectedSegment,
      history,
      isExclude:
        LOCAL_CHECKBOX_EXCLUDE() == "true" &&
        LOCAL_ISOLATED_METRICS() == "true",
      measureGeneral,
      params: {
        id_measure: idMeasure,
        id_survey: measureTotal.id_survey,
        id_division: idDivisionSelected || idDivisionParent,
        id_segment: selectedSegment,
      },
    }
    getListQuestions(params)
  }

  if (props.isLoadingQuestions) {
    return (
      <Fragment>
        <div className="boxShadow QualitativeQuestion loadingSpin">
          <Spin size="large" />
        </div>
      </Fragment>
    )
  }

  if (
    !validate.exist(props.onlyQuestions) ||
    props.onlyQuestions.length === 0
  ) {
    return null
  }

  return (
    <QualitativeQuestion
      measure={props.idMeasure}
      questions={props.questions}
      onlyQuestions={props.onlyQuestions}
      ambassadorDivisionSelected={props.idDivisionSelected}
      isAmbassador={isAmbassador}
      parentId={props.idDivisionParent}
      selectedSegment={props.selectedSegment}
    />
  )
}

WidgetQualitativeQuestion.propTypes = {
  typeMeasurement: PropTypes.string,
  idMeasure: PropTypes.number,
  measureTotal: PropTypes.object,
  measureGeneral: PropTypes.object,
  idDivisionSelected: PropTypes.number,
  idDivisionParent: PropTypes.number,
  isLoadingQuestions: PropTypes.bool,
  questions: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  onlyQuestions: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  selectedSegment: PropTypes.number,
}

const mapStateToProps = createStructuredSelector({
  isLoadingQuestions: makeSelectIsLoadingQuestions(),
  questions: makeSelectQuestions(),
  onlyQuestions: makeSelectOnlyQuestions(),
})

function mapDispatchToProps(dispatch) {
  return {
    getListQuestions: (params) => dispatch(getListQuestionsWatcher(params)),
  }
}

const withConnect = connect(mapStateToProps, mapDispatchToProps)
const withReducer = injectReducer({
  key: "widgetQualitativeQuestionV2",
  reducer,
})
const withSaga = injectSaga({ key: "widgetQualitativeQuestionV2", saga })

export default compose(
  withReducer,
  withSaga,
  withConnect
)(WidgetQualitativeQuestion)
